<template>
  <div class="container pt-0 m:pt-20 l:pt-10">
    <b-headline type="h2" typography="h2" class="text-center mb-2">
      {{ $t("headline") }}
    </b-headline>
    <p class="text-center mb-8" v-html="$t('subheadline')" />
    <div class="grid grid-cols-12 w-full">
      <format-banner variant="blinks" class="col-span-12 l:col-span-6 mb-4 m:mb-6 l:mb-0" />
      <format-banner variant="shortcasts" class="col-span-12 l:col-span-6" />
    </div>
  </div>
</template>

<script>
import BHeadline from "@/component-library/b-headline"
import FormatBanner from "@/component-library/format-banner"

export default {
  name: "FormatBannerSection",
  components: {
    FormatBanner,
    BHeadline
  },
  i18n: {
    messages: {
      en: {
        headline: "So what do you get?",
        subheadline:
          '<span class="text-blue font-bold">A Premium account</span> with access to the full Blinkist catalouge'
      },
      de: {
        headline: "Das ist Blinkist Premium",
        subheadline: "Das Beste aus Sachbüchern & Podcasts"
      }
    }
  }
}
</script>
